import { useNavigate, useSearchParams } from "react-router-dom";
import { useBranding } from "../../shared/branding";
import { AuthShell } from "../../shared/AuthShell";
import { safeReturnTo } from "../../shared/returnTo";
import { RegisterForm } from "./RegisterForm";

export function RegisterPage() {
  const [search] = useSearchParams();
  const navigate = useNavigate();
  const returnTo = safeReturnTo(search.get("return_to"));
  const branding = useBranding(search.get("client_id"));
  return (
    <AuthShell
      branding={branding}
      title={`Create your account for ${branding.name}`}
    >
      <RegisterForm
        returnTo={returnTo}
        onSwitch={() => navigate(`/login${window.location.search}`)}
      />
    </AuthShell>
  );
}
